import nutritionArticles from './NutritionArticles';
import workoutsArticles from './WorkoutsArticles';
import mentalHealthArticles from './MentalHealthArticles';
import wellnessArticles from './WellnessArticles';

const articles = [
  ...nutritionArticles,
  ...workoutsArticles,
  ...mentalHealthArticles,
  ...wellnessArticles
];

export default articles;
